// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34G0F","importantInfo":"styles_importantInfo__-Pedd"};